import { defaultOptionValue } from './option-types';


export class Option {
  option: string|number;
  title: string|number;
  selected?: boolean;

  constructor(option?: string|number, title?: string|number, selected?: boolean) {
    this.option = option ? option : defaultOptionValue;
    this.title = title ? title : '-';
    this.selected = selected;
  }
}
